module.exports = __webpack_public_path__ + "static/img/tiao.66ee91d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tiao.png
// module id = RtFE
// module chunks = 0